var _excluded = ["size"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
var HealthTestGraphicIcon = function HealthTestGraphicIcon(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 48 : _props$size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "HEALTH-TEST-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.434 18.402a.5.5 0 01.492.41l.008.09v3.067c0 1.072-.83 1.95-1.882 2.028l-.152.005H5.1c-1.072 0-1.95-.83-2.028-1.881l-.006-.152v-3.067a.5.5 0 01.992-.09l.008.09v3.067c0 .533.403.971.921 1.027l.113.006h13.8c.533 0 .972-.403 1.028-.92l.006-.113v-3.067a.5.5 0 01.5-.5zm-4.1-12.534c0 .7-.568 1.267-1.267 1.267H8.933c-.7 0-1.267-.567-1.267-1.267v-1.8H5.1c-.533 0-.972.403-1.028.92l-.006.114v7.667a.5.5 0 01-.992.09l-.008-.09V5.102c0-1.072.83-1.95 1.882-2.028l.152-.006h2.566V2.8c0-.655.499-1.195 1.138-1.26l.13-.006.482-.001.07-.134a2.74 2.74 0 012.366-1.402l.143.003.152-.003A2.74 2.74 0 0114.52 1.4l.069.134h.479c.656 0 1.195.5 1.26 1.138l.007.13v.266H18.9c1.072 0 1.95.83 2.028 1.882l.006.152v7.667a.5.5 0 01-.992.09l-.008-.09V5.102c0-.533-.403-.972-.921-1.028l-.113-.006h-2.567zM12.175.998l-.146.003-.212-.002a1.739 1.739 0 00-1.591 1.193.5.5 0 01-.475.343h-.818a.267.267 0 00-.267.266v3.067c0 .148.12.267.267.267h6.134c.147 0 .267-.12.267-.267V2.801a.267.267 0 00-.267-.266h-.813a.5.5 0 01-.475-.344 1.739 1.739 0 00-1.75-1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.928 11.322c.313.017.59.2.733.473l.047.107 2.34 6.437 2.237-5.032a.883.883 0 01.675-.514l.112-.01a.883.883 0 01.753.391l.057.098 1.03 2.063h6.589a.5.5 0 01.491.41l.009.09a.5.5 0 01-.41.492l-.09.008h-6.66a.884.884 0 01-.734-.392l-.056-.096-.954-1.908-2.246 5.057a.883.883 0 01-.723.534l-.12.005a.883.883 0 01-.757-.479l-.046-.109-2.345-6.449-1.674 3.35a.884.884 0 01-.68.48l-.11.007H.499a.5.5 0 01-.09-.992l.09-.008h5.825l1.763-3.526a.883.883 0 01.724-.486l.117-.001z"
  }))));
};
HealthTestGraphicIcon.displayName = "HealthTestGraphicIcon";
HealthTestGraphicIcon.displayName = "HealthTestGraphicIcon";
HealthTestGraphicIcon.iconName = "HealthTest";
export default HealthTestGraphicIcon;